<template>
  <div>
    <div class="bj dis-cent">
      <div class="content">
        <div class="headBox">
          <div class="title">请选择岗位或零工</div>
          <div class="inpBox">
            <div class="iconfont icon-search search dis-cent"></div>
            <div class="box">
              <input
                type="text"
                placeholder="请输入名称搜索"
                v-model="searChTxt"
                @keyup.enter="searchClick"
              />
            </div>
          </div>
          <div class="youBox">
            <div class="iconfont icon-close close" @click="delClick"></div>
          </div>
        </div>
        <div class="cont">
          <div class="contRig">
            <div class="typeList">
              <div
                class="text dis-cent"
                :class="typeListOn == item.id ? 'on' : ''"
                v-for="(item, index) in typeList"
                @click="contClick(item)"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="nrCont" v-if="typeListOn == 1">
              <!-- <Kong v-if="list.length == 0" /> -->
              <kong-gw v-if="list.length == 0" />
              <div
                class="li"
                v-for="item in list"
                :class="item.id == listOn ? 'contOn' : ''"
                @click="listClick(item.id, item)"
              >
                <div class="kuangBox dis-cent">
                  <div
                    class="kuang dis-cent"
                    :class="item.id == listOn ? 'on' : ''"
                  >
                    <div
                      class="iconfont icon-right"
                      v-if="item.id == listOn"
                    ></div>
                  </div>
                </div>
                <div class="txtCont">
                  <div class="name c-1">{{ item.jobs_name }}</div>
                  <div class="money">
                    {{
                      item.minwage == 0 && item.maxwage == 0
                        ? "面议"
                        : item.minwage + "-" + item.maxwage + "K"
                    }}
                  </div>
                </div>
                <div class="zhuangtai">
                  <div class="yuan"></div>
                  <div class="name">
                    {{ item.display == 1 ? "开放中" : "已关闭" }}
                  </div>
                </div>
              </div>
              <div class="fenye" v-if="totalCount > 8">
                <a-pagination
                  :default-current="page.pageNo"
                  v-model="page.pageNo"
                  :total="totalCount"
                  :page-size="8"
                  @change="pageOnChange"
                />
              </div>
            </div>
            <div class="nrCont" v-if="typeListOn == 2">
              <kong-gw v-if="oddList.length == 0" />
              <div
                class="li"
                v-for="item in oddList"
                :class="item.id == listOn ? 'contOn' : ''"
                @click="listClick(item.id, item)"
              >
                <div class="kuangBox dis-cent">
                  <div
                    class="kuang dis-cent"
                    :class="item.id == listOn ? 'on' : ''"
                  >
                    <div
                      class="iconfont icon-right"
                      v-if="item.id == listOn"
                    ></div>
                  </div>
                </div>
                <div class="txtCont">
                  <div class="name c-1">{{ item.name }}</div>
                  <div class="money">
                    {{ item.price }}元/{{ item.way == 1 ? "件" : "小时" }}
                  </div>
                </div>
                <div class="zhuangtai">
                  <div class="yuan"></div>
                  <div class="name">
                    {{ item.display == 1 ? "开放中" : "已关闭" }}
                  </div>
                </div>
              </div>
              <div class="fenye" v-if="totalCount > 8">
                <a-pagination
                  :default-current="page.pageNo"
                  v-model="page.pageNo"
                  :total="totalCount"
                  :page-size="8"
                  @change="pageOnChange"
                />
              </div>
            </div>
            <div class="diCont">
              <div class="name"></div>
              <div class="btn dis-cent" @click="gbClick">确认</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Kong from "./kong.vue";
import KongGw from "./kongGw.vue";

export default {
  components: {
    Kong,
    KongGw,
  },
  name: "",
  data() {
    return {
      totalCount: 0,
      contOn: null,
      typeList: [
        {
          id: "1",
          name: "岗位列表",
        },
        {
          id: "2",
          name: "零工列表",
        },
      ],
      xzList: [],
      typeListOn: 1,
      typeListTxt: "",
      listOn: null,
      list: [],
      searChTxt: "",
      oddList: [],
      page: {
        pageNo: 1,
        pageSize: 8,
      },
    };
  },
  props: ["member_id"],
  created() {
    this.listGet();
    this.oddListGet();
  },
  methods: {
    pageOnChange(i) {
      this.page.pageNo = i;
      if (this.typeListOn == 1) {
        this.listGet();
      } else {
        this.oddListGet();
      }
    },
    listGet() {
      this.page.display = 1;
      this.page.jobs_name = this.searChTxt;
      this.$get("/nozzle/web/company_job", this.page).then((res) => {
        console.log(res);
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    oddListGet() {
      this.page.display = 1;
      this.page.jobs_name = this.searChTxt;
      this.$get("/nozzle/web/company_odd", this.page).then((res) => {
        console.log(res);
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          this.oddList = res.data;
        } else {
          this.oddList = [];
        }
      });
    },
    searchClick() {
      this.page.pageNo = 1;
      this.totalCount = 0;
      if (this.typeListOn == 1) {
        this.listGet();
      } else {
        this.oddListGet();
      }
    },
    listClick(i, item) {
      this.listOn = i;
      this.xzData = item;
    },
    typeGet() {
      this.$get("/common/category_gets", {
        pageNo: -1,
      }).then((res) => {
        window.localStorage.setItem("category_gets", JSON.stringify(res.data));
        this.typeHcGet(res.data);
      });
    },
    delClick() {
      this.$emit("show");
    },
    gbClick() {
      console.log(this.member_id);
      if (!this.listOn) {
        this.$message.error("请选择一个岗位或零工");
        return;
      }
      let data = {
        id: this.member_id,
        user_type: 2,
      };
      if (this.typeListOn == 1) {
        data.job_id = this.listOn;
      } else {
        data.odd_id = this.listOn;
      }
      this.$post("/chat/chat_begin", data).then((res) => {
        // console.log(res);
        if (res.data.status == 1) {
          this.$router.push({
            path: "/gongsi/message",
            query: {
              id: this.member_id,
              job_id: this.listOn,
            },
          });
          // window.open(
          //   "#/gongsi/message?id=" + this.member_id + "&job_id=" + this.listOn
          // );
          this.$emit("show");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    contClick(item) {
      this.typeListOn = item.id;
      this.listOn = null;
      this.page.pageNo = 1;
      this.totalCount = 0;
      if (this.typeListOn == 1) {
        this.listGet();
      } else {
        this.oddListGet();
      }
    },
    mrGet() {},
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  border-radius: 10px;
  width: 850px;
  height: 600px;
  .headBox {
    height: 70px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ebebeb;
    .title {
      font-weight: 600;
      font-size: 18px;
      width: 220px;
    }
    .inpBox {
      width: 250px;
      height: 30px;
      border-radius: 5px;
      // background-color: #f0f0f0;
      display: flex;
      .search {
        height: 30px;
        width: 40px;
        font-weight: 600;
        color: #9c9c9c;
        font-size: 18px;
      }
      .box {
        width: calc(100% - 40px);
        height: 30px;
        position: relative;
        left: -4px;
        input {
          width: 100%;
          height: 100%;
        }
      }
    }
    .youBox {
      width: 380px;
      display: flex;
      justify-content: flex-end;
      .close {
        font-weight: 600;
        font-size: 22px;
        cursor: pointer;
      }
    }
  }
  .cont {
    display: flex;
    height: calc(100% - 70px);
    .contLeft {
      width: 210px;
      border-right: 1px solid #ebebeb;
      box-sizing: border-box;
      overflow: auto;
      height: 100%;
      padding: 15px;
      .text {
        padding: 0 10px;
        height: 35px;
        border-radius: 5px;
        margin-bottom: 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        .name {
          width: calc(100% - 20px);
        }
        .num {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          color: #fff;
          background: #147ee0;
          font-size: 12px;
        }
      }
      .on {
        background-color: #e6ecf7;
        font-weight: 600;
        color: #147ee0;
      }
      .text:hover {
        background-color: #e6ecf7;
        color: #147ee0;
        font-weight: 600;
      }
    }
    .contRig {
      width: 100%;
      overflow: hidden;
      position: relative;
      .typeList {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        .text {
          padding: 0 13px;
          height: 30px;
          border-radius: 5px;
          background-color: #eef1f5;
          border: 1px solid #eef1f5;
          color: #000;
          margin-right: 15px;
          cursor: pointer;
          box-sizing: border-box;
        }
        .text:hover {
          box-sizing: border-box;
          border: 1px solid #147ee0;
          color: #147ee0;
          background-color: #e6ecf7;
        }
        .on {
          box-sizing: border-box;
          border: 1px solid #147ee0;
          color: #147ee0;
          background-color: #e6ecf7;
        }
      }
      .nrCont {
        padding: 0 20px 20px;
        height: calc(100% - 140px);
        box-sizing: border-box;
        width: 100%;
        overflow: auto;
        .li {
          border: 1px solid #ebebeb;
          border-radius: 10px;
          padding: 20px 0;
          display: flex;
          margin-bottom: 10px;
          cursor: pointer;
          align-items: center;
          width: calc(50% - 7.5px);
          float: left;
          margin-right: 15px;
          padding-right: 10px;
          box-sizing: border-box;
          .kuangBox {
            width: 50px;
            .kuang {
              width: 18px;
              height: 18px;
              border-radius: 5px;
              border: 1px solid #c9c9c9;
            }
            .on {
              border: 1px solid #147ee0;
              background-color: #147ee0;
              color: #fff;
            }
          }
          .txtCont {
            width: calc(100% - 110px);
            display: flex;
            align-items: center;
            .name {
              font-size: 14px;
              max-width: calc(100% - 60px);
              padding-right: 10px;
            }
            .money {
              font-weight: 600;
              font-size: 16px;
              color: #f80d0d;
              // width: 60px;
            }
            .textBox {
              display: flex;
              align-items: center;
              font-size: 13px;
              color: #9c9c9c;
              margin-top: 10px;
              .shu {
                width: 1px;
                height: 12px;
                background-color: #e0e0e0;
                margin: 0 10px;
              }
            }
          }
          .zhuangtai {
            display: flex;
            align-items: center;
            width: 60px;
            .yuan {
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color: #1a78ec;
              margin-right: 5px;
            }
          }
        }
        .li:nth-child(2n) {
          margin-right: 0;
        }
        .contOn {
          border: 1px solid #147ee0;
        }
        .cont:hover {
          border: 1px solid #147ee0;
        }
      }
      .diCont {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name {
          width: 200px;
        }
        .btn {
          width: 80px;
          height: 38px;
          border-radius: 38px;
          background-color: #147ee0;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
